import { Modal } from "react-bootstrap";

interface Props {
    isShown: boolean
    onConfirm: () => void
    onClose: () => void
}

/**
 * E-irsaliyeyi geri çekmeden önce onay. Geri çekme belgeyi iptal eder ve
 * irsaliye numarasını serbest bırakır; aynı numarayla bir daha gönderilemez,
 * yeniden gönderimde Uyumsoft yeni numara verir. Numarayı korumak isteyen
 * kullanıcı bunun yerine "Taslağa Çevir"i kullanmalı.
 */
const CancelDraftConfirmModal = ({ isShown, onConfirm, onClose }: Props) => {
    return (
        <Modal
            tabIndex={-1}
            dialogClassName='modal-dialog modal-dialog-centered mw-600px'
            show={isShown}
            onHide={onClose}
            backdrop={'static'}
            keyboard={false}
        >
            <div className='modal-header'>
                <h2 className='mb-0'>E-İrsaliye geri çekilecek</h2>
            </div>

            <div className='modal-body'>
                <div className='alert alert-danger d-flex align-items-start p-4 mb-5'>
                    <i className='fa fa-exclamation-triangle text-danger fs-2 me-3 mt-1'></i>
                    <div>
                        <div className='fw-bold mb-1'>İrsaliye numarası kullanılamayacak, emin misiniz?</div>
                        <div>Geri çekme belgeyi iptal eder ve irsaliye numarasını serbest bırakır. Siparişi düzeltip yeniden gönderdiğinizde Uyumsoft yeni bir irsaliye numarası verir.</div>
                    </div>
                </div>

                <div className='fs-6 text-gray-700'>
                    Numaranın korunmasını istiyorsanız bunun yerine <b>E-İrsaliye Taslağa Çevir</b> işlemini kullanın; belge taslağa döner, numara aynı kalır.
                </div>
            </div>

            <div className="modal-footer">
                <button onClick={onClose} type="button" className="btn btn-light">
                    Vazgeç
                </button>
                <button onClick={onConfirm} type="button" className="btn btn-danger">
                    Evet, geri çek
                </button>
            </div>
        </Modal>
    )
}

export default CancelDraftConfirmModal;
